import each from 'lodash/each'

type UserRef = {
  id?: string
}

type NodeEntity = {
  data?: {
    content?: string
    creator?: UserRef | string | null
    readers?: unknown[] | Record<string, unknown>
    writers?: unknown[] | Record<string, unknown>
  }
}

export const getNodeText = (node?: NodeEntity) => {
  let content = node?.data?.content
  if (!content) {
    content = ''
  }
  return `(${content})`
}

export const getUsersForNode = (node?: NodeEntity) => {
  const userIds: string[] = []
  const creator = node?.data?.creator
  if (typeof creator === 'string') {
    userIds.push(creator)
  } else if (creator?.id) {
    userIds.push(creator.id)
  }

  each(node?.data?.readers, (r: unknown) => {
    const reader = r as UserRef
    if (reader?.id) {
      userIds.push(reader.id)
    }
  })

  each(node?.data?.writers, (w: unknown) => {
    const writer = w as UserRef
    if (writer?.id) {
      userIds.push(writer.id)
    }
  })

  return userIds
}
